module.exports = __webpack_public_path__ + "static/media/alt_route_selected.3f099713.svg";